export default __webpack_public_path__ + "static/media/other_cards_02_es.e095cf6a.png";